import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import FadeIn from "../common/FadeIn";

const Failure = () => {
  return (
    <FadeIn delay={250} duration={450}>
      <Container className='pt-5 pb-5'>
        <Row>
          <Col>
            <div className='shadow p-4 loginForm mx-auto'>
              <h1>Sorry, there was a problem with that transaction.</h1>
              <p>
                Please check your card details. In this case, the bill has generated and you can
                still pay it in your dashboard to reserve your space. Please
                contact us if you require further assistance.
              </p>
              <Button as={Link} to={`/dashboard/`} variant='primary' className='mt-3 mb-3'>
                Dashboard
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </FadeIn>
  );
};

//export the component
export default Failure;
